// extracted by mini-css-extract-plugin
export default {"root":"TheInstrument_root__AU4LA"};